import React from "react";
import { Outlet } from "react-router-dom";

export const FileCabinet = (): JSX.Element => {
  return <Outlet />;
};
